import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

interface PlanData {
    plan: string;
    count: number;
    color: string;
    percentage: number;
}

interface PlanDistributionChartProps {
    data: PlanData[];
}

export default function PlanDistributionChart({ data = [] }: PlanDistributionChartProps) {
    const hasData = data.length > 0;

    // Map tailwind bg colors to hex for Recharts
    const getColorHex = (tailwindClass: string) => {
        if (tailwindClass.includes('purple')) return '#a855f7';
        if (tailwindClass.includes('teal')) return '#14b8a6';
        if (tailwindClass.includes('blue')) return '#3b82f6';
        if (tailwindClass.includes('slate')) return '#64748b';
        return '#cbd5e1';
    };

    return (
        <div className="bg-white rounded-2xl p-6 border border-slate-200 h-full">
             <h3 className="text-lg font-bold text-slate-800 mb-6">Distribución de Planes</h3>
            
            <div className="h-64">
                {hasData ? (
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={80}
                                paddingAngle={5}
                                dataKey="count"
                                nameKey="plan"
                            >
                                {data.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={getColorHex(entry.color)} />
                                ))}
                            </Pie>
                            <Tooltip 
                                formatter={(value: number) => [`${value} empresas`, 'Cantidad']}
                                contentStyle={{ borderRadius: '12px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
                            />
                            <Legend verticalAlign="bottom" height={36}/>
                        </PieChart>
                    </ResponsiveContainer>
                ) : (
                    <div className="h-full flex flex-col items-center justify-center text-slate-400">
                        <p>No hay datos de planes</p>
                    </div>
                )}
            </div>
        </div>
    );
}
